import { StyleSheet } from 'aphrodite';

// 旋转动画
const rotate = {
  '0%': {
    transform: 'rotate(0deg)',
  },
  '50%': {
    transform: 'rotate(180deg)',
  },
  '100%': {
    transform: 'rotate(360deg)',
  },
};

export default StyleSheet.create({
  container: {
    // maxWidth: '1440px',
    width: '100%',
    margin: '0 auto',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'rgba(246,248,249,1)',
  },
  header: {
    width: '100%',
    height: '660px',
    alignItems: 'center',
    backgroundImage: `url(${require('./assets/headerBg.jpg')})`,
    backgroundSize: '100% 100%',
    backgroundRepeat: 'no-repeat',
    backgroundColor: 'white',
  },
  headerTitle: {
    width: '100%',
    alignItems: 'flex-start',
  },
  titleLogo: {
    marginTop: 28,
    marginLeft: 20,
    width: '58px',
  },
  hyLogo: {
    marginTop: 28,
    marginLeft: 20,
    width: '96px',
  },
  surveyContainer: {
    width: '880px',
    height: '100px',
    marginTop: 56,
    background: 'rgba(255,255,255,1)',
    boxShadow: '0px 2px 20px 0px rgba(0,0,0,0.1)',
    borderRadius: '60px',
    padding: '15px 40px 20px',
  },
  tips: {
    marginTop: 16,
    color: 'rgba(255,255,255,0.5)',
    fontSize: '12px',
    fontFamily: 'MicrosoftYaHei',
    lineHeight: '17px',
  },
  title: {
    width: '480px',
    height: '40px',
    backgroundSize: '100% 100%',
    backgroundPosition: '720px 56px',
  },
  message: {
    marginLeft: '234px',
    marginTop: '9px',
    fontFamily: 'MicrosoftYaHei',
    color: 'rgba(255,255,255,1)',
    lineHeight: '19px',
    fontSize: '14px',
    fontWeight: 'bolder',
    flexDirection: 'row',
  },
  date: {
    marginTop: '16px',
    fontSize: '18px',
    fontFamily: 'PingFangSC-Regular',
    fontWeight: 400,
    color: 'rgba(255,255,255,1)',
    lineHeight: '25px',
  },
  scores: {
    width: '100%',
    flexDirection: 'row',
    justifyContent: 'space-around',
    fontFamily: 'PingFangSC',
    alignItems: 'center',
  },
  score: {
    flex: 1,
    height: 65,
    alignItems: 'center',
  },
  interval: {
    width: 1,
    height: 20,
    background: 'rgba(220,230,236,1)',
  },
  scoreItem: {
    width: '100%',
    alignItems: 'center',
    fontSize: '32px',
    fontWeight: 600,
    color: '#385DAE',
    lineHeight: '45px',
  },
  scoreItemFail: {
    width: '72px',
    height: '47px',
    justifyContent: 'center',
    fontSize: '18px',
    fontFamily: 'MicrosoftYaHei',
    color: 'rgba(252,98,56,1)',
    lineHeight: '24px',
  },
  scoreTitle: {
    fontSize: '12px',
    fontWeight: 400,
    color: 'rgba(129,140,150,1)',
    lineHeight: '17px',
  },
  being: {
    marginTop: 120,
    fontFamily: 'MicrosoftYaHei',
    lineHeight: '17px',
    color: 'white',
  },
  synthesize: {
    width: '880px',
    height: '250px',
    paddingTop: '40px',
    flexDirection: 'row',
  },
  synthesizeGraph: {
    width: '300px',
    height: '100%',
    marginRight: '80px',
    flexDirection: 'row',
    justifyContent: 'space-around',
    alignItems: 'center',
    position: 'relative',
  },
  rectangle: {
    width: 300,
    height: 1,
    background: 'rgba(220,230,236,1)',
    opacity: 0.2347,
    position: 'absolute',
    left: 0,
    bottom: 26,
  },
  synthesizeEvaluate: {
    flex: 1,
    height: '100%',
  },
  class: {
    height: '100%',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
  graph: {
    width: 10,
    background: 'rgba(255,216,70,1)',
    borderRadius: '5px',
    marginTop: 8,
  },
  circle: {
    marginTop: 8,
    width: 3,
    height: 3,
    background: 'rgba(220,230,236,1)',
    borderRadius: '1.5px',
  },
  classText: {
    marginTop: 8,
    textAlign: 'center',
    fontSize: '12px',
    fontFamily: 'PingFangSC-Regular',
    fontWeight: 400,
    color: 'rgba(220,230,236,1)',
    lineHeight: '17px',
  },
  commentTitle: {
    backgroundImage: `url(${require('./assets/titleBlank1.png')})`,
    backgroundSize: '100% 100%',
    backgroundRepeat: 'no-repeat',
    width: 101,
    height: 32,
    fontSize: '14px',
    fontFamily: 'PingFangSC-Semibold',
    fontWeight: 600,
    color: 'rgba(255,255,255,1)',
    lineHeight: '20px',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: '8px',
  },
  commentIcon: {
    display: 'inline-block',
    width: 6,
    height: 6,
    borderRadius: 3,
    backgroundColor: 'rgba(255,255,255,1)',
    marginRight: 10,
    marginTop: '12px',

  },
  commentText: {
    fontSize: '12px',
    fontFamily: 'PingFangSC-Regular',
    fontWeight: 400,
    color: 'rgba(255,255,255,1)',
    lineHeight: '21px',
    marginLeft: '16px',
  },
  contentText: {
    textIndent: '-16px',
  },
  singleAnalysis: {
    position: 'relative',
    width: '1000px',
    alignItems: 'center',
    marginTop: '67px',
  },
  singleTitle: {
    backgroundImage: `url(${require('./assets/titleBg.png')})`,
    backgroundSize: '100%  100%',
    backgroundRepeat: 'no-repeat',
    width: 95,
    height: 65,
    fontSize: '23px',
    fontWeight: 500,
    alignItems: 'center',
    justifyContent: 'center',
  },
  reading: {
    width: '100%',
    height: '500px',
    flexDirection: 'row',
    marginTop: '40px',
  },
  readingArea: {
    backgroundColor: 'white',
    height: '100%',
  },
  area: {
    width: '600px',
    padding: '0px 40px',
  },
  commentTitleSingle: {
    color: 'rgba(56,93,174,1)',
    marginTop: '40px',
    backgroundImage: `url(${require('./assets/titleBlank2.png')})`,
  },
  commentTextSingle: {
    color: 'rgba(50,54,58,1)',
    marginTop: '20px',
  },
  commentIconSingle: {
    backgroundColor: 'black',
  },
  readingAccuracy: {
    width: '400px',
    height: '100%',
    backgroundSize: '100% 100%',
    backgroundRepeat: 'no-repeat',
    padding: '30px 0 0 30px',
    position: 'relative',
  },
  subjectTitleBg: {
    fontFamily: 'FZLTTHJW--GB1-0',
    fontWeight: 'bold',
    color: 'rgba(255,255,255,0.07)',
    lineHeight: '70px',
    fontSize: '56px',
  },
  subjectTitles: {
    width: '305px',
    height: '70px',
    position: 'relative',
  },
  subjectTitle: {
    fontSize: '32px',
    fontFamily: 'FZLTTHJW--GB1-0',
    // fontWeight: 'bold',
    color: 'rgba(255,255,255,1)',
    lineHeight: '40px',
    position: 'absolute',
    left: 0,
    bottom: 0,
  },
  radarArea: {
    backgroundImage: `url(${require('./assets/radarBg.png')})`,
    backgroundSize: '210px 210px',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: '63px 48px',
    position: 'relative',
  },
  radar: {
  },
  radarBeingContainer: {
    justifyContent: 'center',
    alignItems: 'center',
    position: 'absolute',
    top: 49,
    left: 63,
  },
  radarBeing: {
    backgroundImage: `url(${require('./assets/rotate.png')})`,
    backgroundSize: '100%  100%',
    backgroundRepeat: 'no-repeat',
    width: '210px',
    height: '210px',
    animationName: [rotate],
    animationDuration: '5.5s',
    animationIterationCount: 'infinite',
    animationTimingFunction: 'linear',
  },
  radarText: {
    fontSize: '12px',
    fontFamily: 'PingFangSC-Regular',
    fontWeight: 400,
    color: 'rgba(255,255,255,1)',
    lineHeight: '17px',
    marginTop: 60,
  },
  noContent: {
    fontSize: '12px',
    fontFamily: 'PingFangSC-Regular',
    fontWeight: 400,
    color: 'rgba(50,54,58,1)',
    lineHeight: '17px',
  },
  projectForPorduct: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    width: '100%',
    height: 100,
    background: 'rgba(255,255,255,1)',
    boxShadow: '0px 2px 10px 0px rgba(0,0,0,0.05)',
    alignItems: 'center',
  },
  bgForPorduct: {
    width: '1000px',
    flexDirection: 'row',
    padding: '0 40px',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  contentForPorduct: {
    flexDirection: 'row',
    width: 600,
    marginRight: '167px',
  },
  project: {
    width: 178,
    height: 17,
  },
  projectContent: {
    padding: '20px 0 15px 25px',
    wrap: 'wrap',
  },
  textForPorduct: {
    width: '480px',
    marginTop: '13px',
    display: 'inline-block',
    fontSize: 12,
    fontFamily: 'PingFangSC-Regular',
    fontWeight: 400,
    lineHeight: '20px',
  },
  tip: {
    color: '#FF8E04',
  },
  xiaozhi: {
    width: 100,
    height: 100,
  },
  code: {
    width: 100,
    height: 100,
  },
  projectTitle1: {
    fontSize: 24,
    fontFamily: ' PingFangSC-Semibold',
    fontWeight: 600,
    color: 'rgba(56,93,174,1)',
    lineHeight: '33px',
  },
  top: {
    flexDirection: 'row',
    justifyContent: 'center',
    position: 'relative',
    width: '100%',
    height: 68,
  },

  btns: {
    flexDirection: 'row',
    fontSize: 17,
    height: 17,
    lineHeight: '17px',
    fontFamily: 'PingFangSC-Semibold',
    fontWeight: 600,
    color: 'rgba(135,143,152,1)',
  },

  btn: {
    textAlign: 'center',
    cursor: 'pointer',
    marginRight: '69px',
    ':last-child': {
      marginRight: '0px',
    },
  },

  exportAnswer: {
    position: 'absolute',
    top: 0,
    right: 0,
    color: '#385DAE',
    cursor: 'pointer',
  },

  exportAnswerLoading: {
    right: -12,
    color: '#878f98',
  },

  exportAnswerHover: {
    ':hover': {
      borderBottom: '1px #385DAE solid',
    },
  },

  selectedBtn: {
    color: '#32363A',
    position: 'relative',
    '::after': {
      position: 'absolute',
      width: '24px',
      height: '2px',
      bottom: '-8px',
      left: '50%',
      transform: 'translateX(-50%)',
      backgroundColor: '#385DAE',
      content: '""',
      borderRadius: '1px',
    },
  },
  ring: {
    width: '100%',
    height: '100%',
    position: 'absolute',
    top: 24,
    left: 0,
  },

  exportAnswerTop: {
    top: 22,
  },
});



// WEBPACK FOOTER //
// ./src/components/report/evaluation_report/styles.js